import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import TestingGate from "./components/TestingGate";

// Public Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";

// Public Pages
import Home from "./pages/Home";
import Books from "./pages/Books";
import BookDetail from "./pages/BookDetail";
import Activities from "./pages/Activities";
import Blog from "./pages/Blog";
import About from "./pages/About";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import MyBooks from "./pages/MyBooks";
import BookReader from "./pages/BookReader";

// Admin Pages
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import DashboardHome from "./pages/admin/DashboardHome";
import BooksManagement from "./pages/admin/BooksManagement";
import AddBook from "./pages/admin/AddBook";
import UsersManagement from "./pages/admin/UsersManagement";
import PricingManagement from "./pages/admin/PricingManagement";
import SubscribersManagement from "./pages/admin/SubscribersManagement";
import BlogManagement from "./pages/admin/BlogManagement";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
            <ScrollToTop />
            <TestingGate>
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Navbar />
                <Home />
                <Footer />
                <CartDrawer />
              </>
            } />
            <Route path="/books" element={
              <>
                <Navbar />
                <Books />
                <Footer />
                <CartDrawer />
              </>
            } />
            <Route path="/books/:id" element={
              <>
                <Navbar />
                <BookDetail />
                <Footer />
                <CartDrawer />
              </>
            } />
            <Route path="/activities" element={
              <>
                <Navbar />
                <Activities />
                <Footer />
                <CartDrawer />
              </>
            } />
            <Route path="/blog" element={
              <>
                <Navbar />
                <Blog />
                <Footer />
                <CartDrawer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <About />
                <Footer />
                <CartDrawer />
              </>
            } />
            <Route path="/checkout" element={
              <>
                <Navbar />
                <Checkout />
                <Footer />
              </>
            } />
            <Route path="/order-confirmation" element={
              <>
                <Navbar />
                <OrderConfirmation />
                <Footer />
              </>
            } />
            <Route path="/my-books" element={
              <>
                <Navbar />
                <MyBooks />
                <Footer />
              </>
            } />
            <Route path="/read/:bookId" element={<BookReader />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route path="dashboard" element={<DashboardHome />} />
              <Route path="books" element={<BooksManagement />} />
              <Route path="books/add" element={<AddBook />} />
              <Route path="blog" element={<BlogManagement />} />
              <Route path="users" element={
                <ProtectedRoute adminOnly>
                  <UsersManagement />
                </ProtectedRoute>
              } />
              <Route path="pricing" element={
                <ProtectedRoute adminOnly>
                  <PricingManagement />
                </ProtectedRoute>
              } />
              <Route path="subscribers" element={
                <ProtectedRoute adminOnly>
                  <SubscribersManagement />
                </ProtectedRoute>
              } />
            </Route>
          </Routes>
          <Toaster position="top-center" />
          </TestingGate>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
